/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState, useRef } from "react";
import { NavLink } from "react-router-dom";
import Logo from "../../images/logo.png";
import HomeContactUsModal from "../homeContactUsModal/homeContactUs";
import { useNavigate } from "react-router-dom";
import "./header.css";

const Header = (props) => {
  const history = useNavigate();
  const hamburger = useRef(0);
  const [open, setOpen] = useState(false);
  const activeClass = useRef(0);
  const isContactOnly = props.isContactOnly || false;
  const isInterviewMode = props.isInterviewMode || false;

  const gotoEmployer = () => {
    history("/demo");
  };
  const goToHomePage = () => {
    history("/");
  };
  const openSupportModal = () => {
    setOpen(true);
  };

  const _modalClose = () => {
    setOpen(false);
  };
  const hamburgerClicked = () => {
    const x = document.getElementById("myLinks");
    if (x.style.display === "block") {
      x.style.display = "none";
    } else {
      x.style.display = "block";
    }
  };
  const gotoSignin = () => {
    history("/signIn");
  };
  const goToRecruiterSignUp = () => {
    history("/recruiter-signup");
  };
  const goToReferral = () => {
    history("/referral");
  };

  return (
    <>
      {isInterviewMode ? (
        <div className="header_interview">
          <div className="header_logoContainer_interview">
            <img src={Logo} alt="Logo" className="logo_interview" />
          </div>
        </div>
      ) : (
        <>
          <div className="nav_bg_home home-specific-header">
            <div className="container w1200 nav_bg_home_section">
              <div className="nav_bg_left">
                <li
                  className="cp"
                  onClick={() => goToHomePage()}
                  style={{ listStyle: "none" }}
                >
                  <span>
                    <img src={Logo} className="nav_logo_home" alt="img" />
                  </span>
                </li>
              </div>
              <div className="nav_bg_right">
                <ul className="navbar_home">
                  {!isContactOnly && (
                    <>
                      <NavLink to="/basic-info-form">
                        <button type="button" className="btn-home btn-start">
                          Register & Take Test
                        </button>
                      </NavLink>
                      <li
                        onClick={gotoSignin}
                        className={
                          window.location.href.includes("signIn")
                            ? "active-link special_hover cp"
                            : "special_hover cp"
                        }
                      >
                        <span>Sign-In</span>
                      </li>
                      <li
                        onClick={goToRecruiterSignUp}
                        className={
                          window.location.href.includes("recruiter-signup")
                            ? "active-link special_hover cp"
                            : "special_hover cp"
                        }
                      >
                        <span>Customer Sign-Up</span>
                      </li>
                      <li
                        className={
                          window.location.href.includes("employer")
                            ? "active-link special_hover cp"
                            : "special_hover cp"
                        }
                        onClick={() => gotoEmployer()}
                        ref={activeClass}
                      >
                        <span>Request Demo</span>
                      </li>
                      <li
                        onClick={goToReferral}
                        className={
                          window.location.href.includes("referral")
                            ? "active-link special_hover cp"
                            : "special_hover cp"
                        }
                      >
                        <span>Referrals</span>
                      </li>
                    </>
                  )}
                  <li className="special_hover cp" onClick={openSupportModal}>
                    <span>Contact Us</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="nav_bg_home_responsive">
            <div className="nav_bg_home_responsive-wrapper">
              <div className="home-top-nav">
                <li
                  className="cp"
                  onClick={() => goToHomePage()}
                  style={{ listStyle: "none" }}
                >
                  <span>
                    <img src={Logo} className="nav_logo_home" alt="img" />
                  </span>
                </li>

                <div id="myLinks" ref={hamburger}>
                  <ul className="navbar_home-responsive">
                    <li>
                      <NavLink to="/basic-info-form">
                        <button type="button" className="btn-home btn-start">
                          Register & Take Test
                        </button>
                      </NavLink>
                    </li>
                    <li
                      onClick={() => history("/signIn")}
                      className={
                        window.location.href.includes("signIn")
                          ? "active-link special_hover cp"
                          : "special_hover cp"
                      }
                    >
                      <a>Sign-In</a>
                    </li>
                    <li
                      onClick={goToRecruiterSignUp}
                      className="special_hover cp"
                    >
                      <span>Customer Sign-Up</span>
                    </li>
                    <li
                      className={
                        window.location.href.includes("employer")
                          ? "active-link special_hover cp"
                          : "special_hover cp"
                      }
                      onClick={() => gotoEmployer()}
                      ref={activeClass}
                    >
                      <span>Request Demo</span>
                    </li>
                    <li
                      onClick={goToReferral}
                      className={
                        window.location.href.includes("referral")
                          ? "active-link special_hover cp"
                          : "special_hover cp"
                      }
                    >
                      <span>Referrals</span>
                    </li>
                    <li className="special_hover cp" onClick={openSupportModal}>
                      <span>Contact Us</span>
                    </li>
                  </ul>
                </div>
                <span className="icon" onClick={hamburgerClicked}>
                  <i className="fa fa-bars"></i>
                </span>
              </div>
            </div>
          </div>
        </>
      )}
      <HomeContactUsModal modalOpen={open} modalClose={_modalClose} />
    </>
  );
};
export default Header;
